const CONNECTED = 'connected';
const NOT_AUTHORIZED = 'not_authorized';
const UNKNOWN = 'unknown';

export { CONNECTED, NOT_AUTHORIZED, UNKNOWN };
